export default __webpack_public_path__ + "static/0252-b78eb660e946b21ea3e371b1c060ae50.png";